import SysValidations from "config/lang/SysValidations";

const Validations = {
  ...SysValidations,
  typeRequired: "Marque si el socio es cliente o proveedor",
};

export default Validations;
